import * as Yup from "yup";

export const CreateNewPasswordScheme = Yup.object({
    // email: Yup.string().email().required("Please enter your email"),
    password: Yup.string().min(6).required("Please enter your password"),
    confirm_password: Yup.string()
        .required('Confirm password is required')
        .oneOf([Yup.ref("password"), null], "Password must match"),
});






